const CRAWLER_ATTEMPT_TIMEOUT_MS = 40000;
const CRAWLER_NODE_ATTEMPTS = 2;
const TRACKER_DATA_PARTS = 4;
const POST_PROCESS_ALLOWANCE_MS = 60000;

const TRACKER_DATA_REQUEST_TIMEOUT_MS = TRACKER_DATA_PARTS
    * CRAWLER_NODE_ATTEMPTS * CRAWLER_ATTEMPT_TIMEOUT_MS + POST_PROCESS_ALLOWANCE_MS;
const TRACKER_AUTHORIZATION_TIMEOUT_MS = TRACKER_DATA_REQUEST_TIMEOUT_MS
    + 2 * CRAWLER_ATTEMPT_TIMEOUT_MS;
const TRACKER_MATCH_PAGE_TIMEOUT_MS = CRAWLER_NODE_ATTEMPTS
    * CRAWLER_ATTEMPT_TIMEOUT_MS + 20000;
const RIOT_REFRESH_COMPLETION_WAIT_MS = 120000;
const RIOT_DATA_REQUEST_TIMEOUT_MS = 130000;

module.exports = {
    RIOT_DATA_REQUEST_TIMEOUT_MS,
    RIOT_REFRESH_COMPLETION_WAIT_MS,
    TRACKER_AUTHORIZATION_TIMEOUT_MS,
    TRACKER_DATA_REQUEST_TIMEOUT_MS,
    TRACKER_MATCH_PAGE_TIMEOUT_MS,
};
